// @ts-ignore
import overlandparkmeta from "../assets/images/overlandparkmeta.jpg";
// @ts-ignore
import bgImage from "../assets/images/treeservice2.jpg";
import {Box, Button, Container, Flex, Grid, Heading, Link, List, ListItem, Stack, Text, VStack} from "@chakra-ui/react";
import {posts} from "./posts";
import React from "react";
import {TreeRemovalContent} from "../Components/TreeRemoval/TreeRemoval";
import {TreeTrimmingContent} from "../Components/TreeTrimming/TreeTrimming";
import {TreePruningContent} from "../Components/TreePruning/TreePruning";
import {StumpGrindingContent} from "../Components/StumpGrinding/StumpGrinding";
import {TreeHealthConsultingContent} from "../Components/TreeHealthConsulting/TreeHealthConsulting";
import {LandClearingContent} from "../Components/LandClearing/LandClearing";
import {TreePlanting} from "../Components/TreePlanting/TreePlanting";
import {EmergencyTreeService} from "../Components/EmergencyTreeService/EmergencyTreeService";
import {ArboristConsultingContent} from "../Components/ArboristConsulting/ArboristConsulting";
import {BiConversation, BiCut} from "react-icons/bi";
import {RiEmotionHappyLine} from "react-icons/ri"
import {MdEmergencyShare, MdHealthAndSafety, MdOutlineEmergency, MdOutlineNaturePeople} from "react-icons/md"
import {PiClockCountdownFill} from "react-icons/pi"
import {AiOutlineScissor} from "react-icons/ai"
import {
    GiChainsaw,
    GiChoppedSkull,
    GiLandMine,
    GiStumpRegrowth,
    GiTreeBranch,
    GiTreeDoor,
    GiTreeRoots
} from "react-icons/gi";
import {FaConciergeBell, FaRegHandScissors, FaStar, FaTree, FaUserTie} from "react-icons/fa";
import {faqs} from "./faqs";

const telLink = "tel:9136752522";

export const SiteData = {
    hoursOfOperation: "24/7",
    city: "Overland Park,KS",
    phoneNumber: "(913) 675-2522",
    phoneNumberWithDashes: "913-675-2522",
    telLink,
    buttonCtaText: () => (
        <Flex>
            Ready for Expert Tree Care? Schedule Your&nbsp;
            <Text textDecoration={"underline"} display={"inline"}>
                Free Consultation Today!
            </Text>
        </Flex>
    ),
    keywords:
        "Tree Care, services, professional, affordable, experienced, trimming, Overland Park, KS.",
    footerText: "Overland Park Tree Care, All rights reserved.",
    ogImage: overlandparkmeta,
    navLinks: [
        {
            title: "Home",
            href: "/",
        },
        {
            title: "Services",
            href: "/services/",
        },
        {
            title: "Blog",
            href: "/blog/",
        },
        {
            title: "About",
            href: "/about/",
        },
        {
            title: "Contact Us",
            href: "/contact/",
        },
        {
            title: "Careers",
            href: "/careers/",
            hideFromTopNav: true,
        },
    ],
    signupForm: {
        intro: () => (
            <Text>
                Welcome to Overland Park Tree Care, the leading tree service provider in
                Overland Park, KS. Our team of trained arborists understand the local
                botany and landscaping that are specific to our beautiful region and we
                love to bring this sense of expertise to you through any of our
                different services. For the ultimate in tree service, reach out to us at{" "}
                <Link href={"tel:9136752522"} textDecoration={"underline"}>
                    913-675-2522
                </Link>{" "}
                today!
            </Text>
        ),
        servicesTitle: "Our Services:",
    },
    homepage: {
        bgImage: bgImage,
        url: "https://www.overlandparktreecare.com",
        metaData: {
            title:
                "Overland Park Tree Care | Expert Tree Service Provider",
            description:
                "Trust Overland Park Tree Care for all your tree service needs. Contact us at 913-675-2522 for professional and quality tree care in Overland Park.",
        },
        h1: "Tree Service Company in Overland Park, Kansas",
        subtitle:
            "Your Trusted Partner for Professional Tree Care in Overland Park, Kansas",
        servicesTitle: "Why Overland Park Residents Choose Our Tree Services",
        values: [
            {
                id: 0,
                number: "5000+",
                name: "Trees Serviced",
                icon: GiTreeBranch,
            },
            {
                id: 4,
                number: (
                    <>
                        <Flex my={3}>
                            <FaStar fontSize={"1.9rem"}/>
                            <FaStar fontSize={"1.9rem"}/>
                            <FaStar fontSize={"1.9rem"}/>
                            <FaStar fontSize={"1.9rem"}/>
                            <FaStar fontSize={"1.9rem"}/>
                        </Flex>
                    </>
                ),
                name: "Experienced Technicians",
                icon: FaUserTie,
            },
            {
                id: 2,
                number: "98%",
                name: "Customer Satisfaction",
                icon: RiEmotionHappyLine,
            },
            {
                id: 3,
                number: "24h",
                name: "Emergency Response Time",
                icon: PiClockCountdownFill,
            },
        ],
        services: [
            {
                id: '0',
                text: () => <Text>
                    <b>Highly Skilled Arborists:</b> Our team of certified arborists is simply unmatched. Most of us are
                    local, so we understand our region's specific <a href="https://www.landscapinghawthorne.com/"
                                                                     target={'_blank'} rel={'noreferrer'}>
                    tree service
                </a> and landscaping needs. We bring years of <a href={"https://treeserviceshobart.com/"}
                                                                 target={'_blank'} rel={'noreferrer'}>tree services</a>
                    &nbsp;experience and expertise to every project, ensuring the health and beauty of your trees and
                    landscapes are maintained with precision.
                </Text>
            },
            {
                id: '1',
                text: () => <Text>
                    <b>Safe and Efficient Overland Park Tree Services:</b> We prioritize our team's and property
                    occupants' safety
                    during every project. Our <a href="https://www.landscapinglincolnca.com/" target={'_blank'}
                                                 rel={'noreferrer'}>
                    tree service company
                </a> adheres to strict safety protocols. It employs
                    advanced <a href="https://www.landscapingredondobeach.com/" target={'_blank'} rel={'noreferrer'}>
                    tree service technology
                </a> to ensure a secure environment throughout. Your safety and
                    satisfaction are our top priorities.
                </Text>
            },
            {
                id: '2',
                text: () => <Text>
                    <b>Competitive Pricing:</b> Our high-quality tree care and <a
                    href="https://www.desplainestreeservice.com" target={"_blank"} rel={'noreferrer'}>
                    tree removal</a> services are fair and
                    competitive. We strive to ensure our customers feel good about our pricing, fostering long-term
                    relationships built on trust and value. Contact us today for a quote!
                </Text>
            },
            {
                id: '3',
                text: () => <Text>
                    <b>Comprehensive Tree Care:</b> Our services encompass a wide range of needs. Whether it's
                    fertilization, spraying, pruning, stump grinding, or addressing storm damage, our team is equipped
                    to handle it all. Your trees are in capable hands.
                </Text>
            },
            {
                id: '4',
                text: () => <Text>
                    <b>Local Experience:</b> Our experience and reputation speak volumes as Overland Park locals. We
                    do a great job at intimately understanding the trees and landscape of the region, allowing us to
                    provide tailored
                    assessments and solutions for every project. Trust our expertise to meet your tree care needs.
                </Text>
            }
        ],
        content: [
            <>
                <Heading as="h2" size={"md"} pb="2">
                    Arbor Excellence in Overland Park, KS
                </Heading>
                <VStack spacing={4} align="left">
                    <Text>Introducing Overland Park Tree Care, your premier choice for expert arbor services in Overland
                        Park and the Kansas City area. Our team is dedicated to offering a detailed suite of services
                        customized to meet
                        the diverse needs of your trees and landscapes. Whether you require precision <a
                            href="https://johnsoncitytreeservice.com/" target="_blank" rel="noreferrer">tree removal</a>,
                        artistic tree sculpting, effective stump eradication, or holistic tree wellness programs, we
                        have the expertise and tools to enhance the vitality and aesthetics of your outdoor spaces. Our
                        commitment to excellence extends beyond mere tree care; we strive to be stewards of your
                        environment, promoting sustainability and ecological balance in every project we undertake.
                        Customer satisfaction and quality are our primary focuses. At Overland Park Tree Care, we are
                        ready to exceed your expectations in Johnson County and beyond. Servicing Overland Park to
                        Olathe KS, we are always ready to elevate the health and beauty of your trees.</Text>

                    <Heading as="h2" size="md">Tailored Tree Care Solutions</Heading>
                    <List spacing={2}>
                        <ListItem>
                            <Link href="/tree-trimming/" fontWeight="bold">
                                Tree Sculpting:
                            </Link> We use advanced trimming and pruning techniques to foster tree health and visual
                            charm. Our arborists employ precision cuts and sculpting methods to improve the natural
                            beauty of your trees while promoting their overall health and longevity.
                        </ListItem>
                        <ListItem>
                            <Link href="/stump-grinding/" fontWeight="bold">
                                Stump Eradication:
                            </Link> Utilizing safe, efficient methods for stump removal, enhancing the functionality of
                            your landscape. Our stump grinding services ensure the removal of unsightly stumps, allowing
                            for seamless landscaping and improved safety.
                        </ListItem>
                        <ListItem>
                            <Link href="/tree-health-consulting/" fontWeight="bold">
                                Holistic Tree Upkeep:
                            </Link> We offer a spectrum of tree health and preservation services for enduring tree care.
                            From soil analysis to pest management, our holistic approach ensures your trees' long-term
                            health and vitality.
                        </ListItem>
                        <ListItem>
                            <Link href="/tree-planting/" fontWeight="bold">
                                Arbor Cultivation:
                            </Link> Specialized in tree planting and moving, guaranteeing vitality during critical
                            transition phases. Our arborists carefully select and plant trees suited to your landscape,
                            ensuring optimal growth and health.
                        </ListItem>
                        <ListItem>
                            <Link href="/arborist-consultations/" fontWeight="bold">
                                Arboreal Advisory:
                            </Link> Gain insights and advice from our certified arborists for strategic tree management.
                            Our arborists provide personalized consultations to address your tree care needs and offer
                            expert guidance for ongoing maintenance and management.
                        </ListItem>
                        <ListItem>
                            <Link href="/emergency-tree-services/" fontWeight="bold">
                                Critical Tree Services:
                            </Link> Depend on our swift and reliable solutions for urgent arbor care needs. Whether an
                            ash tree falls or you discover an infestation of the emerald ash borer, our team is always
                            available 24/7 to handle emergency tree situations, ensuring prompt and efficient resolution
                            to protect your property and safety.
                        </ListItem>
                        <ListItem>
                            <Link href="/arborist-consultations/" fontWeight="bold">
                                Arborist Expertise:
                            </Link> Focused consultations on tree health, risk evaluation, and stewardship. Our
                            certified arborists offer expert assessment and recommendations to optimize your trees'
                            health and structural integrity, ensuring their long-term vitality and safety.
                        </ListItem>
                        <ListItem>
                            <Link href="/land-clearing/" fontWeight="bold">
                                Eco-Smart Land Preparation:
                            </Link> We offer comprehensive and environmentally conscious land clearing services. We
                            employ eco-friendly practices and equipment to clear land responsibly, minimizing
                            environmental impact while preparing your site for development or landscaping projects.
                        </ListItem>
                    </List>

                    <Text>Commitment to Eco-Responsibility and Superior Quality</Text>
                    <Text>At Overland Park Tree Care, our dedication goes beyond delivering top-tier services. We are
                        deeply committed to eco-friendly practices, aiming to enhance the longevity and health of your
                        trees, thus contributing to the overall aesthetic and safety of your environment. Our
                        eco-conscious approach encompasses everything from sustainable tree care techniques to
                        responsible waste management. We strive to create a greener, healthier community for future
                        generations by minimizing our environmental footprint.</Text>

                    <Text>Why Select Overland Park Tree Care?</Text>
                    <Text>Choosing us means aligning with a <a href={"https://www.puyalluptreeservice.net/"}
                                                               target={"_blank"} rel={"noreferrer"}>tree
                        service</a> known for:</Text>
                    <List spacing={2}>
                        <ListItem>Comprehensive expertise in diverse tree care domains. Our team of arborists brings
                            extensive knowledge and experience to every project, ensuring that all aspects of tree care
                            are addressed with precision and professionalism.</ListItem>
                        <ListItem>Sustainable and eco-conscious practices. We are committed to environmentally friendly
                            tree care practices in all our operations, from tree care techniques to waste management, to
                            minimize our ecological impact and promote a healthier environment.</ListItem>
                        <ListItem>Efficient, professional, and reliable service provision. Our team is dedicated to
                            high-quality service and timely and professional delivery. You can rely on us to complete
                            your tree care projects efficiently and professionally.</ListItem>
                        <ListItem>Personalized solutions addressing your unique arbor requirements. We understand that
                            every tree and landscape differs, so we provide customized solutions to meet your needs and
                            requirements. We strive to ensure your trees get the care they need to thrive.</ListItem>
                        <ListItem>Superior quality services at market-competitive rates. We are committed to providing
                            excellent quality tree care services at competitive rates. At Overland Park Tree Care, you
                            can expect exceptional service without enormous costs.</ListItem>
                    </List>
                    <Text>We strive to magnify Overland Park's natural allure through exceptional tree care and a focus
                        on client satisfaction.</Text>

                    <Text>Ready to Serve All Your Arbor Needs</Text>
                    <Text>Our skilled team is always prepared to deliver professional and dependable tree care services,
                        ensuring your trees' health and property's safety. Whether regular maintenance, emergency arbor
                        care, or lawn care, we support you.</Text>

                    <Text>Contact Overland Park Tree Care</Text>
                    <Text>Experience the distinct quality of Overland Park Tree Care. For expert arbor services in
                        Overland Park, KS, call us at 123-456-7890. Request your free, customized quote today and
                        discover why we are the region's top choice for tree care. Your tree care goals are our
                        priority.</Text>
                </VStack>

                <Button
                    as={"a"}
                    href={"tel:9136752522"}
                    bg={"#17b644"}
                    fontSize={{base: "20px", md: "23px"}}
                    color={"white"}
                    fontWeight={"bold"}
                    _hover={{bg: "#06c03b", color: "white", cursor: "pointer"}}
                    p={"16px 30px"}
                    borderRadius={0}
                    mt={"2rem"}
                    lineHeight={"26px"}
                    minH={"66px"}
                    width={"100%"}
                    maxW={"400px"}
                >
                    <i className="fa fa-phone" aria-hidden="true"/>
                    &nbsp;&nbsp;Call for Immediate Assistance
                </Button>
            </>,
        ],
        additionalContent:
            <>
                <Container maxW="container.xl">
                    <VStack spacing={4} align="left">
                        <Text>Regarding Professional Tree Care in the Overland Park area, Overland Park Tree Care
                            emerges as a trusted leader. Our dedicated team is committed to providing top-notch tree
                            care services to improve the health and beauty of your trees. Discover the difference with
                            Overland Park Tree Care, where expertise meets a passion for preserving the natural beauty
                            of your landscape.</Text>

                        <Heading as="h2" size="md">Our Tree Care Expertise</Heading>
                        <Text>With a profound understanding of local flora and tree health, our Overland Park Tree Care
                            team is dedicated to delivering high-quality and unmatched tree service. We employ the
                            latest techniques and arborist practices to ensure the well-being and longevity of your
                            trees.</Text>

                        <Heading as="h3" size="sm">Comprehensive Tree Care Services</Heading>
                        <List spacing={2}>
                            <ListItem>
                                <Link href="/tree-pruning/" fontWeight="bold">
                                    Tree Pruning:
                                </Link> Enhance the structure and health of your trees with our professional pruning
                                services.
                            </ListItem>
                            <ListItem>
                                <Link href="/tree-removal/" fontWeight="bold">
                                    Tree Removal:
                                </Link> Safely and effectively remove unwanted or hazardous trees from your property.
                            </ListItem>
                            <ListItem>
                                <Link href="/tree-trimming/" fontWeight="bold">
                                    Tree Trimming:
                                </Link> Maintain the aesthetic appeal of your trees and promote healthy growth with
                                regular trimming.
                            </ListItem>
                            <ListItem>
                                <Link href="/stump-grinding/" fontWeight="bold">
                                    Stump Grinding:
                                </Link> Remove unsightly tree stumps to enhance the visual appeal of your landscape.
                            </ListItem>
                            <ListItem>
                                <Link href="/tree-health-consulting/" fontWeight="bold">
                                    Tree Health Consulting:
                                </Link> Ensure the well-being of your trees with expert consulting services.
                            </ListItem>
                            <ListItem>
                                <Link href="/tree-planting/" fontWeight="bold">
                                    Tree Planting:
                                </Link> Our professional services add beauty and value to your property.
                            </ListItem>
                            <ListItem>
                                <Link href="/arborist-consultations/" fontWeight="bold">
                                    Arborist Consultations:
                                </Link> Consult with our certified arborists for personalized tree care recommendations.
                            </ListItem>
                            <ListItem>
                                <Link href="/land-clearing/" fontWeight="bold">
                                    Land Clearing:
                                </Link> Prepare your land for development or landscaping projects with our efficient
                                land-clearing services.
                            </ListItem>
                            <ListItem>
                                <Link href="/emergency-tree-services/" fontWeight="bold">
                                    Emergency Tree Services:
                                </Link> In times of unexpected tree emergencies, Overland Park Tree Care offers fast,
                                reliable, and safe emergency tree care services in Overland Park, KS, and the
                                surrounding areas.
                            </ListItem>
                        </List>

                        <Heading as="h4" size="sm">Our Process - Ensuring Healthy Trees Every Step of the Way</Heading>
                        <Text>At Overland Park Tree Care, our process is customized to promote the longevity and health
                            of your trees while providing you with a seamless experience:</Text>
                        <List spacing={2}>
                            <ListItem>Initial Assessment: We begin with a detailed audit of your trees' health and
                                specific care needs.</ListItem>
                            <ListItem>Customized Care Plan: Based on our thorough assessment, we create a tailored care
                                plan designed to address your trees' unique requirements.</ListItem>
                            <ListItem>Expert Execution: Our certified arborists implement the care plan with precision
                                and expertise, ensuring optimal results.</ListItem>
                            <ListItem>Quality Assurance: We conduct post-service evaluations to ensure our work meets
                                high quality and satisfaction standards.</ListItem>
                            <ListItem>Follow-Up Care: We provide ongoing guidance and support to help you maintain the
                                health and beauty of your trees for years to come.</ListItem>
                        </List>

                        <Heading as="h5" size="sm">Why Choose Overland Park Tree Care?</Heading>
                        <Text>In a market filled with tree care options, Overland Park Tree Care stands out for several
                            vital reasons that resonate with our customers in the Overland Park area:</Text>
                        <List spacing={2}>
                            <ListItem>Local Expertise: Our deep understanding of the local ecosystem enables us to
                                provide tailored tree care solutions.</ListItem>
                            <ListItem>Certified Arborists: Our team consists of many accredited arborists dedicated to
                                maintaining the beauty and health of your trees.</ListItem>
                            <ListItem>Customer-Centric Approach: Your satisfaction is our priority. We listen to your
                                tree care needs and tailor our services accordingly.</ListItem>
                            <ListItem>Environmentally Conscious: We prioritize eco-friendly practices in our tree care
                                services, promoting sustainability.</ListItem>
                            <ListItem>Comprehensive Services: We cover all your tree care needs, from initial assessment
                                to post-service guidance.</ListItem>
                        </List>
                        <Box as="section" pt={10}>
                            <Heading as="h2" size="lg" mb={4}>
                                Frequently Asked Questions (FAQs) About Tree Care
                            </Heading>
                            <Grid templateColumns={{base: "repeat(1, 1fr)", md: "repeat(2, 1fr)"}} gap={6}>
                                {faqs.map(({question, answer}, index) => (
                                    <Box
                                        p={5}
                                        borderWidth="1px"
                                        borderRadius="lg"
                                        key={index}
                                    >
                                        <Heading as={"h3"} fontSize="xl">{question}</Heading>
                                        <Text mt={4}>{answer}</Text>
                                    </Box>
                                ))}
                            </Grid>
                        </Box>

                        <Box as="section" pt={10}>
                            <Heading as="h2" size="lg" mb={4}>
                                Begin Your Journey to Healthy Trees Today
                            </Heading>
                            <Text mb={4}>
                                Ready to give your trees the care they deserve? Contact Overland Park Tree Care today to
                                schedule a
                                consultation and take the first step toward vibrant, healthy trees that enhance the
                                beauty and value of
                                your property.
                            </Text>
                            <Button colorScheme="green" size="md" mb={4} as={'a'} href={telLink}>
                                Contact Us Now
                            </Button>
                        </Box>
                    </VStack>
                </Container>
            </>,
        footerHeading: "Contact Overland Park Tree Care",
        footerText: () => (
            <>
                For professional tree services in Overland Park and the surrounding
                areas, reach out to us today. Call or fill out our{" "}
                <Link href={"/contact/"}>online contact form</Link> for non-emergency
                inquiries and someone from our team will reach out to you. Our team is
                here for you and all of your tree care needs!
            </>
        ),
        footerText2: "Your Trees Health and Beauty is Our Priority",
        servicesHeader:
            "Our Extensive Range of Tree Services for All Your Arboricultural Needs",
        servicesSubtitle: () => (
            <Text color="muted" fontSize={{base: "lg", md: "xl"}}>
                Explore our <Link href={"/services"}>suite of services</Link>, Overland Park Tree
                Care is your one-stop solution for all tree-related needs
            </Text>
        ),
        featuredServices: [
            {
                name: "24 Hour Emergency Tree Removal",
                description:
                    "Overland Park Tree Care provides reliable 24-hour emergency tree service, ensuring that we're always on standby to handle critical situations threatening the safety of your property.",
                icon: GiChainsaw,
                path: "/tree-removal/",
                linkTitle: "Tree Trimming",
            },
            {
                name: "Tree Trimming and Pruning",
                description:
                    "We offer complete tree trimming and pruning services to uphold the health and aesthetics of your trees, contributing to the overall beauty of your outdoor spaces.",
                icon: BiCut,
                path: "/tree-trimming/",
                linkTitle: "Stump Grinding",
            },
            {
                name: "Stump Grinding and Removal",
                description:
                    "We specialize in stump grinding and removal, aiming to safely and efficiently clear unwanted stumps from your yard, enhancing the usability of your landscape.",
                icon: GiTreeRoots,
                path: "/stump-grinding/",
                linkTitle: "Stump Grinding",
            },
            {
                name: "Tree Maintenance",
                description:
                    "Seeking to maintain your trees' health over the long haul? We offer a diverse range of tree health and maintenance services tailored to the unique needs of your trees .",
                icon: FaTree,
                path: "/tree-health-consulting/",
                linkTitle: "Tree Maintenance",
            },
            {
                name: "Tree Planting and Transplanting",
                description:
                    "Our tree planting and transplanting service guarantees optimal care and handling of your trees during transit, ideal for those wishing to relocate trees without causing them distress.",
                icon: GiTreeDoor,
                path: "/tree-health-consulting/",
                linkTitle: "Tree Planting and Transplanting",
            },
            {
                name: "Tree Health Consulting",
                description:
                    "Require professional advice on your trees? Our certified arborist consulting service can equip you with the necessary insight and recommendations to make informed decisions about your tree care.",
                icon: FaConciergeBell,
                path: "/tree-health-consulting/",
                linkTitle: "Tree Health Consulting",
            },
            {
                name: "Emergency Tree Services",
                description:
                    "When emergencies strike, rely on us for swift and dependable emergency services. Our team is well-prepared to address urgent tree care needs arising from storms, damage, or other unforeseen events.",
                icon: MdOutlineEmergency,
                path: "/emergency-tree-services/",
                linkTitle: "Emergency Tree Services",
            },
            {
                name: "Arborist Consultations",
                description:
                    "Elevate your tree care with our professional arborist consultations. Our experts provide valuable insights and solutions, emphasizing tree health, risk assessment, and sustainable management practices.",
                icon: MdOutlineNaturePeople,
                path: "/arborist-consultations/",
                linkTitle: "Arborist Consultations",
            },
            {
                name: "Land Clearing",
                description:
                    "Prepare your property efficiently and responsibly with our comprehensive land clearing services. Whether it's for construction, landscaping, or agricultural projects, we ensure an eco-friendly process that enhances efficiency.",
                icon: FaRegHandScissors,
                path: "/land-clearing/",
                linkTitle: "Land Clearing",
            },
        ],
    },
    careers: {
        url: "https://www.overlandparktreecare.com/careers/",
        metaData: {
            title:
                "Join Our Team - Career Opportunities at Overland Park Tree Care",
            description:
                "Explore career opportunities in arboriculture at Overland Park Tree Care. Join our team of tree care experts in Kansas. Passionate individuals wanted!",
        },
        h1: "We're Hiring - Become a Part of Overland Park Tree Care Service",
        h2: [
            "Why Join Overland Park Tree Care Service?",
            "Current Openings for Tree Care Specialists",
            "Our Commitment to Employee Development and Satisfaction",
        ],
        headingText: {
            whyJoin:
                "Discover a workplace where your passion for trees and the environment is valued. Join a team committed to providing exceptional tree care services in Overland Park, KS.",
            openings:
                "Browse our current job openings for arborists, tree climbers, and grounds maintenance staff. Find a role that aligns with your skills and passion for tree care.",
            commitment:
                "At Overland Park Tree Care Service, we believe in investing in our team's expertise and providing a supportive, dynamic work environment. Your growth in the field of arboriculture is integral to our success.",
        },
        content: [
            <Text>
                Welcome to the Careers section at{" "}
                <Link href={"/"}>Overland Park Tree Care Service</Link>, where your
                career in arboriculture and tree care can flourish. We're a family of
                professionals dedicated to the highest standards in tree services. Join
                us in making a positive impact in Overland Park, KS.
            </Text>,
            <Text>
                At <Link href={"/"}>Overland Park Tree Care Service</Link>, we
                understand that our strength comes from our people. We are looking for
                dedicated individuals who share our commitment to exceptional tree care.
                Whether you're an experienced arborist or eager to learn, we offer a
                workplace where your skills are appreciated and nurtured.
            </Text>,
            <Text>
                Our employees enjoy a culture that promotes personal and professional
                growth. We provide comprehensive training, competitive compensation, and
                the opportunity to work with advanced tree care equipment. Our goal is
                to create a safe, rewarding, and enjoyable workplace for everyone on our
                team.
            </Text>,
            <Text>
                As a key part of Overland Park's community, we take pride in serving our
                neighbors with integrity and professionalism. Our commitment to service
                excellence extends to our team members, whom we support with a positive
                work environment, respectful teamwork, and opportunities for career
                advancement.
            </Text>,
            <Text>
                Are you ready to join a leading tree service provider in Overland Park,
                KS? Check out our current job openings and find where you fit in our
                growing team. From skilled tree climbers, to customer service
                representatives, there's a place for you at Overland Park Tree Care
                Service.
            </Text>,
            <Text>
                <a href="https://www.overlandparktreecare.com/careers/">
                    Discover your next career opportunity
                </a>{" "}
                with us. Be a part of a team that's dedicated to preserving and
                enhancing the urban canopy. At{" "}
                <Link href={"/"}>Overland Park Tree Care Service</Link>, we're more than
                just a company; we're a community. Apply today and grow your career in
                tree care.
            </Text>,
        ],
    },
    about: {
        url: "https://www.overlandparktreecare.com/about/",
        metaData: {
            title: "Professional Tree Services in Overland Park | Tree Care Experts",
            description: "Trust our reliable tree company for expert arboricultural services in Overland Park. Contact us today for all your tree care needs.",
        },
        h1: "Tree Services in Overland Park, TN",
        h2: [
            "Emergency Tree Services: Available 24/7 for urgent tree care and removal needs.",
            "Experienced Arborists: Our team of certified arborists is trained and equipped to provide expert tree care.",
            "Comprehensive Tree Care: Offering a wide range of services from tree health assessments to stump grinding.",
            "Eco-Friendly Practices: We prioritize the health of your trees and the environment in every service we provide.",
            "Competitive Pricing: Our services are affordably priced, ensuring quality tree care is accessible to all."
        ],
        headingText: {
            commitment: "Dedicated to delivering exceptional tree care services, ensuring the health and beauty of Overland Park's urban forest.",
            team: "Our team at Overland park Tree Care is composed of passionate arborists and tree care professionals, committed to excellence in every project.",
            services: "Overland park Tree Care offers a full spectrum of tree care services. From routine pruning and maintenance to emergency tree removals and disease management, our services cater to all your tree care needs. We use the latest techniques and equipment to ensure the health and safety of your trees and property. Whether it's a residential garden or a commercial landscape, our team provides professional, efficient, and eco-friendly services."
        },
        services: [
            {
                id: "0",
                title: "Tree Pruning & Trimming",
                href: "/tree-pruning/",
                icon: AiOutlineScissor,
                description: (
                    <Text>
                        Precision pruning and trimming to maintain the health and appearance of your trees, performed by
                        our skilled arborists. Our team employs specialized techniques to ensure your trees receive
                        the care they need to thrive while enhancing their aesthetic appeal.
                    </Text>
                ),
            },
            {
                id: "1",
                title: "Tree Removal",
                href: "/tree-removal/",
                icon: GiChoppedSkull,
                description: (
                    <Text>
                        Safe and efficient tree removal services for hazardous or unwanted trees, ensuring your
                        property’s safety and aesthetic appeal. Our expert arborists utilize advanced equipment
                        and techniques to safely remove trees, minimizing disruption to your landscape and property.
                    </Text>
                ),
            },
            {
                id: "2",
                title: "Stump Grinding & Removal",
                href: "/stump-grinding/",
                icon: GiStumpRegrowth,
                description: (
                    <Text>
                        Comprehensive stump grinding and removal services to clear your landscape and prepare it for new
                        growth or landscaping projects. Our team efficiently removes stumps of any size, leaving your
                        property ready for future landscaping endeavors.
                    </Text>
                ),
            },
            {
                id: "3",
                title: "Emergency Tree Services",
                href: "/emergency-tree-services/",
                icon: MdEmergencyShare,
                description: (
                    <Text>
                        Prompt and reliable emergency tree services for storm damage, fallen trees, or urgent tree care
                        needs. Our dedicated team is available round-the-clock to address emergency situations and
                        safeguard your property from tree-related hazards.
                    </Text>
                ),
            },
            {
                id: "4",
                title: "Tree Health Assessments",
                href: "/tree-health-assessments/",
                icon: MdHealthAndSafety,
                description: (
                    <Text>
                        Expert assessments to diagnose and treat tree diseases and pests, ensuring the longevity and
                        vitality of your trees. Our arborists conduct thorough evaluations to identify potential
                        issues and develop tailored treatment plans to restore and maintain the health of your trees.
                    </Text>
                ),
            },
            {
                id: "5",
                title: "Arborist Consultations",
                href: "/arborist-consultations/",
                icon: BiConversation,
                description: (
                    <Text>
                        Professional arborist consultations to advise on tree care, planting, and maintenance for
                        healthy and sustainable landscapes. Our experienced arborists offer personalized recommendations
                        to help you optimize the health and beauty of your trees, ensuring long-term sustainability
                        and enjoyment of your outdoor spaces.
                    </Text>
                ),
            },
            {
                id: "6",
                title: "Land Clearing & Lot Preparation",
                href: "/land-clearing/",
                icon: GiLandMine,
                description: (
                    <Text>
                        Efficient land clearing services for construction projects, landscaping, and property
                        development, with a focus on environmental responsibility. Our team employs eco-friendly
                        practices and state-of-the-art equipment to clear land efficiently while minimizing
                        environmental impact, ensuring a sustainable approach to land development.
                    </Text>
                ),
            },
        ]
    },
    testimonials: {
        h1: "Testimonials",
        heading:
            "Discover why our customers love us – from tree trimming to emergency tree removal, Overland Park Tree Care is the top-rated choice for all your tree service needs",
        testimonials: [
            {
                avatarUrl: "https://i.pravatar.cc/150?u=a042581f4e29026704f",
                name: "Susan D.",
                logo: undefined,
                title: "Overland Park, KS",
                quote:
                    '"Last fall, we faced a huge challenge when a massive tree in our backyard was struck by lightning. We feared it would damage our home. Overland Park Tree Care swiftly arrived with their team, promptly assessed the situation, and safely removed the tree. Their expertise, professionalism, and efficiency were beyond compare. I wouldn\'t trust anyone else."',
            },
            {
                avatarUrl: "https://i.pravatar.cc/150?u=a0425d",
                name: "Richard F.",
                logo: undefined,
                title: "Overland Park, KS",
                quote:
                    '"I\'ve sought the services of Overland Park Tree Care numerous times for tree trimming. Each time they have impressed me with their knowledge, professionalism, and the quality of their work. They leave my trees looking vibrant and perfectly shaped. Moreover, their post-work cleanup is always impeccable. For any tree care needs in Overland Park, I highly recommend them."',
            },
            {
                avatarUrl: "https://i.pravatar.cc/150?u=a0804d",
                name: "Rob B.",
                logo: undefined,
                title: "Overland Park, TN",
                quote:
                    '"I recently used Overland Park Tree Care Service for a major land clearing project on my property. The level of professionalism and attention to detail was exceptional. They completed the job efficiently, and their concern for environmental impact was evident. They went above and beyond to ensure the land was perfectly prepared for my next project. Highly recommended!"',
            },
        ],
    },
    services: {
        metaData: {
            title:
                "Overland Park Tree Care Services | Expert Tree Service Provider",
            description:
                "Need tree care in Overland Park? From pruning to removal, our expert team offers reliable solutions. Contact us today for top-notch service.",
        },
        h1: "Your Neighborhood Professionals for First-rate Tree Services in Overland Park, KS",
        h2: "The Tree Care Services We Deliver",
        subtext:
            "At Overland Park Tree Care, our commitment is to offer a wide array of tree care services that prioritize your landscape’s health and beauty at affordable prices.",
        footerHeading: "Prepared to Enhance Your Landscape?",
        footerText2: () => (
            <>
                Get in touch with us at{" "}
                <Link href={"tel:9136752522"}>913-675-2522</Link> or use our online
                contact form for a free quote. Experience the Overland Park Tree Care
                difference today!
            </>
        ),
        footerText: () => (
            <>
                Keep in mind, at Overland Park Tree Care, your trees are our primary
                concern. When it comes to tree care in Overland Park, KS, we're the team
                to trust. We're just a call away!
            </>
        ),
        // Neeed tp update
        content: (
            <Box>
                <Stack spacing={5}>
                    <Heading as="h2" size="xl">
                        Overland Park Tree Care Service: Expert Tree Care in Overland Park,
                        TN
                    </Heading>
                    <Text>
                        At Overland Park Tree Care Service, we're dedicated to offering
                        superior tree care and maintenance services in Overland Park, TN.
                        Whether you need routine pruning, emergency tree removal, or
                        specialized arborist advice, our team of certified professionals is
                        ready to provide safe, efficient, and environmentally responsible
                        services. We take pride in our commitment to customer satisfaction
                        and our expertise in handling a wide range of tree-related needs.
                    </Text>

                    <Heading as="h3" size="lg">
                        Why Choose Overland Park Tree Care Service?
                    </Heading>
                    <List spacing={3}>
                        <ListItem>
                            <Text>
                                <b>Experienced Arborists:</b> Our certified arborists bring
                                extensive knowledge and skill to every project, ensuring the
                                highest standards of tree care.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Advanced Tree Care Techniques:</b> We use modern,
                                eco-friendly methods and equipment to provide comprehensive tree
                                care that prioritizes the health of your trees and the
                                environment.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>24/7 Emergency Services:</b> Understanding that tree
                                emergencies can occur at any time, we offer around-the-clock
                                services to address urgent tree care needs.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Competitive Pricing:</b> We believe in offering high-quality
                                services at fair and transparent prices, delivering value to
                                every client.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Local Expertise:</b> Familiar with the specific tree species
                                and challenges in Overland Park, TN, we provide tailored care
                                for optimal tree health and aesthetics.
                            </Text>
                        </ListItem>
                    </List>

                    <Heading as="h3" size="lg">
                        Comprehensive Tree Care & Maintenance Services
                    </Heading>
                    <List spacing={3}>
                        <ListItem>
                            <Text>
                                <b>Tree Trimming and Pruning:</b> Our precise trimming and
                                pruning services enhance the health and beauty of your trees,
                                contributing to a safer and more appealing landscape.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Emergency Tree Services:</b> Responding swiftly to emergency
                                situations, we handle storm-damaged trees, fallen limbs, and
                                other urgent scenarios with expertise and care.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Stump Grinding and Removal:</b> We provide effective stump
                                grinding services to clear your property and facilitate new
                                landscaping opportunities.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Arborist Consultations:</b> Benefit from our arborist's
                                expert insights on tree health, risk assessment, and proper tree
                                care strategies.
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text>
                                <b>Land Clearing:</b> Our land clearing services prepare your
                                property for new construction, landscaping, or agricultural use,
                                ensuring an efficient and eco-friendly process.
                            </Text>
                        </ListItem>
                    </List>

                    <Heading as="h3" size="lg">
                        Tailored Solutions for Your Trees
                    </Heading>
                    <Text>
                        We recognize that each tree and property has unique needs. Our
                        customized approach ensures that every aspect of your tree care is
                        handled with attention to detail and tailored to your specific
                        requirements.
                    </Text>

                    <Heading as="h3" size="lg">
                        Commitment to Safety and Environmental Care
                    </Heading>
                    <Text>
                        At Overland Park Tree Care Service, your safety and the health of
                        your trees are our top priorities. We're dedicated to providing
                        services that not only meet but exceed industry standards for safety
                        and environmental responsibility.
                    </Text>

                    <Heading as="h3" size="lg">
                        Contact Us for Professional Tree Care
                    </Heading>
                    <Text>
                        For expert tree care and maintenance services in Overland Park, TN,
                        trust Overland Park Tree Care Service. Contact us today for
                        professional, reliable, and eco-conscious tree care solutions.
                    </Text>
                </Stack>
            </Box>
        ),

        services: [
            {
                id: "0",
                text: () => (
                    <Text>
                        <b>
                            <Link href={"/tree-pruning/"}>Tree Pruning</Link> and{" "}
                            <Link href={"/tree-trimming/"}>Trimming:</Link>
                        </b>{" "}
                        tree pruning is the process used to remove unnecessary branches
                        while trimming is used to more specifically address foliage and
                        leafage. Here at Overland Park Tree Care, we offer optimal care on
                        both fronts, leaving your trees looking aesthetically pleasing and
                        healthy.
                    </Text>
                ),
            },
            {
                id: "1",
                text: () => (
                    <Text>
                        <b>
                            <Link href={"/stump-grinding/"}>Stump Grinding</Link>:
                        </b>{" "}
                        Stump grinding is a service that is used to either minimize or
                        remove a bothersome tree stump on your landscape. There are many
                        reasons to take advantage of this service. For some, a tree stump is
                        simply an eyesore. For others, it can be a potential home to
                        insects! Whatever the reason, we’ve got you covered here!
                    </Text>
                ),
            },
            {
                id: "2",
                text: () => (
                    <Text>
                        <b>
                            <Link href={"/tree-removal/"}>Tree Removal</Link>:
                        </b>{" "}
                        If a tree has structural problems, interior decay or simply poses a
                        risk to the property, our team can safely and securely remove it.
                    </Text>
                ),
            },
            {
                id: "3",
                text: () => (
                    <Text>
                        <b>
                            <Link href={"/tree-health-consulting/"}>
                                Tree Health Consulting
                            </Link>
                            :
                        </b>{" "}
                        Unsure if your tree is healthy or not? Let our team of trained
                        arborists assess over a consultation. Our specialists are equipped
                        to offer various treatments for specific needs.
                    </Text>
                ),
            },
        ],
        whyh2: "Why Opt for Overland Park Tree Care?",
        whySubtext: () => (
            <>
                Our team of experts and specialists at Overland Park Tree Care has a
                reputation for delivering unmatched professional tree care services for
                the community for over 30 years. We are a trusted partner for all of
                your tree care requirements and work with your individual needs to
                ensure your trees and property are handled properly. We're your trusted
                partner for any tree care requirements, available at your service at{" "}
                <Link href={"tel:9136752522"} textDecoration={"underline"}>
                    913-675-2522
                </Link>
                .
            </>
        ),
        whyServices: [
            {
                id: "0",
                text: () => (
                    <Text>
                        <b>Skilled Professionals:</b> Our team is highly devoted to what we
                        do and are all trained and experienced professionals in the field.
                        With a deep focus on tree care and a commitment to our customers,
                        there’s no job too big or small for us.
                    </Text>
                ),
            },
            {
                id: "1",
                text: () => (
                    <Text>
                        <b>Superior Service:</b> Our commitment and dedication is nearly
                        unmatched when it comes to our customers and their projects. With
                        us, the client is always first. We make sure to be available for our
                        clients when a project is in progress and work tirelessly until all
                        their needs are met.
                    </Text>
                ),
            },
            {
                id: "2",
                text: () => (
                    <Text>
                        <b>Dependable and Efficient:</b> Our reputation speaks for itself!
                        We’ve gained confidence through the community over the years and
                        consistently deliver for our customers. We are there for you every
                        step of the way.
                    </Text>
                ),
            },
            {
                id: "3",
                text: () => (
                    <Text>
                        <b>Local Specialists:</b> Our team takes into account the botany,
                        topography and landscape of the greater Overland Park area,
                        providing our customers with a sense of confidence in our expertise
                        that is unmatched!
                    </Text>
                ),
            },
        ],
    },
    contact: {
        url: "https://www.overlandparktreecare.com/contact/",
        metaData: {
            title: "Contact Overland Park Tree Care | Call 913-675-2522",
            description:
                "Get in touch with Overland Park Tree Care for expert tree care services in Overland Park, KS. We're here to guarantee the health and allure of your trees.",
        },
        h1: "Overland Park Tree Care",
        subtitle:
            "Thank you for choosing Overland Park Tree Care. We are a dedicated tree service company servicing Overland Park, Kansas, and surrounding areas, providing trustworthy tree care services to our esteemed customers. Our professional and amicable team is ready to aid with all your tree care demands.",
        sectionHeading: "Why Choose Overland Park Tree Care?",
        signUpDescription:
            "If you wish to contact us online, please fill out the form below. We will revert to you as soon as feasible.",
        feedbackText:
            "We appreciate your feedback. If you have any inquiries or concerns, we'd be delighted to hear from you. Your satisfaction remains our utmost priority.",
        closingText:
            <>
                Reliable, professional, and sustainable tree service solutions
            </>
        ,
        valueProps: [
            {
                title: "Expert Arborists:",
                description:
                    "Our certified arborists bring along years of expertise. They know the finest techniques for tree pruning, removal, and general care. We take pride in providing exceptional service, ensuring the health and beauty of your trees.",
            },
            {
                title: "Extensive Tree Services:",
                description:
                    "From routine tree maintenance to tree removal and stump grinding, we offer a broad range of services. Our adept team comes equipped with the right tools to cater to all your tree care needs.",
            },
            {
                title: "Modern Equipment:",
                description:
                    "We utilize high-quality, contemporary equipment to ensure efficient and safe tree care services. Our equipment empowers us to cater for trees of all dimensions and conditions.",
            },
            {
                title: "Environmentally Conscious:",
                description:
                    "We appreciate the importance of trees for our environment and aim to deliver sustainable services. We adhere to best practices to minimize the impact on the environment during tree removal or any other services.",
            },
            {
                title: "Client Satisfaction:",
                description:
                    "At Overland Park Tree Care, our goal is to go beyond your expectations. We are committed to providing excellent customer service and ensure a hassle-free experience from beginning to end.",
            },
        ],
    },
    blog: {
        url: "https://www.overlandparktreecare.com/blog/",
        metaData: {
            title:
                "Overland Park Tree Care - Expert Tree Services | Blog",
            description:
                "Professional tree care services in Overland Park. From trimming to removal, trust us for top-quality tree care at competitive prices. Contact us today!",
        },
        h1: "Overland Park Tree Care Articles and Tips",
        h2: "Our Blog",
        heading:
            "At Overland Park Tree Care, we believe in communicating and educating our customers. Our blog is one of many ways that we aim to stay connected to our customers. Here you will find tips, insights and advice that pertain to your trees and landscaping needs. Of course, we are always only a call away so feel free to reach out at any time. We are here for you!",
        posts: posts,
    },
    treePruning: {
        url: "https://www.overlandparktreecare.com/tree-pruning",
        metaData: {
            title:
                "Expert Tree Pruning Services in Overland Park, KS - Overland Park Tree Care",
            description:
                "Bring out the best in your trees with professional tree pruning services in Overland Park, KS. Contact Overland Park Tree Care at 913-675-2522 today!",
        },
        h1: "Tree Pruning Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "Trees are more than just a feature of your landscape. They are living, breathing organisms that need proper care and maintenance to stay healthy and strong. One of the most effective ways to ensure the health and beauty of your trees is through regular pruning. At Overland Park Tree Care, we offer professional tree pruning services designed to enhance the health, aesthetic, and safety of your trees.",
        body: <TreePruningContent/>,
    },
    treeRemoval: {
        url: "https://www.overlandparktreecare.com/tree-removal/",
        metaData: {
            title:
                "Safe and Efficient Tree Removal in Overland Park, KS",
            description:
                "Overland Park Tree Care offers expert tree removal services in Overland Park, KS. Contact us at 913-675-2522 for reliable and efficient tree removal.",
        },
        h1: "Expert Tree Removal Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "When a tree becomes a hazard or is irreversibly damaged, it may be time for it to come down. At Overland Park Tree Care, we specialize in safe, efficient tree removal services, providing peace of mind to homeowners and businesses throughout Overland Park, KS.",
        body: <TreeRemovalContent/>,
    },
    treeTrimming: {
        url: "https://www.overlandparktreecare.com/tree-trimming/",
        metaData: {
            title:
                "Tree Trimming Experts | Overland Park, KS | Overland Park Tree Care",
            description:
                "Enhance the health and appearance of your trees with expert tree trimming services in Overland Park. Call 913-675-2522 for top-tier tree care.",
        },
        h1: "Professional Tree Trimming Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "Healthy, well-trimmed trees can significantly enhance the beauty and value of your property. At Overland Park Tree Care, we offer professional tree trimming services designed to keep your trees healthy and vibrant throughout the year.",
        body: <TreeTrimmingContent/>,
    },
    stumpGrinding: {
        url: "https://www.overlandparktreecare.com/stump-grinding",
        metaData: {
            title:
                "Overland Park Stump Grinding Services - Tree Care Experts",
            description:
                "Remove tree stumps efficiently with Overland Park Tree Care. Call 913-675-2522 for a free quote on our stump grinding services in Overland Park, KS.",
        },
        h1: "Best Stump Grinding Services in Overland Park, KS | Overland Park Tree Care\n",
        subtitle:
            "If you've recently had a tree removed or have an old tree stump that's become a blemish on your landscape, Overland Park Tree Care has the solution for you. We provide professional and efficient stump grinding services in Overland Park, KS, and the surrounding area.",
        body: <StumpGrindingContent/>,
    },
    treeHealthConsulting: {
        url: "https://www.overlandparktreecare.com/tree-health-consulting",
        metaData: {
            title:
                "Professional Tree Health Consulting in Overland Park, KS",
            description:
                "Seeking professional tree care services in Overland Park? Contact us for expert assistance. Oops, the page you're looking for is missing.",
        },
        h1: "Comprehensive Tree Health Consulting in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "Understanding the health of your trees can be a complex task. That's where we, at Overland Park Tree Care, come in. Our experienced arborists offer comprehensive tree health consulting services designed to ensure the well-being of your trees.",
        body: <TreeHealthConsultingContent/>,
    },
    // Need to update
    landClearing: {
        url: "https://www.overlandparktreecare.com/land-clearing",
        metaData: {
            title:
                "Professional Land Clearing in Overland Park, KS",
            description:
                "Transform your property with professional land clearing services in Overland Park, KS. Contact us for efficient and eco-friendly solutions today!",
        },
        h1: "Best Land Clearing Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "Whether you're preparing for construction, landscaping, or agricultural projects, Overland Park Tree Care offers comprehensive land clearing services in Overland Park, KS, and the surrounding areas.",
        body: <LandClearingContent/>,
    },
    arboristConsulting: {
        url: "https://www.overlandparktreecare.com/arborist-consultations",
        metaData: {
            title:
                "Expert Arborist Consultations in Overland Park, KS",
            description:
                "Get professional arborist consulting for your trees in Overland Park, KS. Expert advice on tree care, health, and maintenance from Overland Park Tree Care.",
        },
        h1: "Expert Arborist Consultation Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "At Overland Park Tree Care, our certified arborists provide expert consulting services to help you understand and manage the trees on your property effectively.",
        body: <ArboristConsultingContent/>,
    },
    treePlanting: {
        url: "https://www.overlandparktreecare.com/tree-planting",
        metaData: {
            title:
                "Professional Tree Planting in Overland Park, KS",
            description:
                "Enhance your landscape with our expert tree planting services in Overland Park, KS. Choose Overland Park Tree Care for sustainable, healthy tree growth.",
        },
        h1: "Tree Planting Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "Overland Park Tree Care offers professional tree planting services, ensuring the health and beauty of your landscape for years to come.",
        body: <TreePlanting/>,
    },
    emergencyTreeServices: {
        url: "https://www.overlandparktreecare.com/emergency-tree-services",
        metaData: {
            title:
                "24/7 Emergency Tree Services in Overland Park, KS",
            description:
                "Immediate response for emergency tree services in Overland Park, KS. Contact Overland Park Tree Care for urgent tree care and removal.",
        },
        h1: "Emergency Tree Services in Overland Park, KS | Overland Park Tree Care",
        subtitle:
            "In times of unexpected tree emergencies, Overland Park Tree Care offers fast, reliable, and safe emergency tree care services in Overland Park, KS, and the surrounding areas.",
        body: <EmergencyTreeService/>,
    },
    404: {
        metaData: {
            title:
                "Overland Park Tree Care Services - 404 Page Not Found",
            description:
                "Oops! The page you're seeking could not be found. Overland Park Tree Care offers professional tree care services. Reach out to us for dependable assistance.",
            siteName: "Tree Service in Overland Park, KS | Call 913-675-2522",
        },
        h1: "404 - Oops, you found a page that's missing its leaves.",
        subtitle: "Regrettably, the page you are hunting for does not exist.",
        p: "Whether you require tree trimming, stump removal, or any other tree care service, we've got you covered. Call us at 913-675-2522 for your tree care needs.",
    },
};
